import React from 'react'
import { BadgeSize } from './SaleBadge/SaleBadge'
import * as Styled from './styled'

export const SaleBadge: React.FC = () => {
  return (
    <>
      <Styled.SaleBadge size={BadgeSize.Large}>
        <Styled.BadgeText>Limited time offer!</Styled.BadgeText>
      </Styled.SaleBadge>
    </>
  )
}
